import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/orderAgreement',
  component: LAYOUT,
  name: 'OrderAgreement',
  redirect: '/orderAgreement/index',
  meta: {
    title: '意向订车协议',
  },
  children: [
    {
      path: 'index',
      name: 'OrderAgreementIndex',
      meta: {
        title: '意向订车协议',
      },
      component: () => import('@/views/orderAgreement/index'),
    },
    {
      path: 'privacy',
      name: 'OrderAgreementPrivacy',
      meta: {
        title: '隐私协议',
      },
      component: () => import('@/views/orderAgreement/privacy'),
    },
    {
      path: 'collection',
      name: 'OrderAgreementCollection',
      meta: {
        title: '个人信息收集清单',
      },
      component: () => import('@/views/orderAgreement/collection'),
    },
    {
      path: 'sharing',
      name: 'OrderAgreementSharing',
      meta: {
        title: '个人信息共享清单',
      },
      component: () => import('@/views/orderAgreement/sharing'),
    },
  ],
};
